module.exports = __webpack_public_path__ + "static/media/opusflow.ff1fd1f6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/opusflow.webp
// module id = 512
// module chunks = 0